
import { HomeCta } from './sections/cta';
import { FeaturedProperties } from './sections/featured-properties';
import { Hero } from './sections/hero';
import { InvestmentTeaser } from './sections/investment-teaser';
import { PopularAreas } from './sections/popular-areas';

import { clientEnv } from '@/lib/env';
import { Seo } from '@/lib/seo';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'RealEstateAgent',
  name: clientEnv.siteName,
  url: clientEnv.siteUrl,
  areaServed: ['Ahmedabad', 'Gandhinagar', 'GIFT City', 'Bavla'],
  knowsAbout: ['Residential real estate', 'Commercial real estate', 'Pre-leased investments'],
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: clientEnv.siteName,
  url: clientEnv.siteUrl,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${clientEnv.siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function HomePage() {
  return (
    <>
      <Seo
        title="Resolute Property Solutions — Premium Real Estate & Investment Intelligence"
        description="Verified, RERA-transparent homes and investment-grade commercial assets across Ahmedabad, Gandhinagar and GIFT City. Search, compare and decide with confidence."
        path="/"
        jsonLd={[organizationJsonLd, websiteJsonLd]}
      />
      <Hero />
      <FeaturedProperties />
      <PopularAreas />
      <InvestmentTeaser />
      <HomeCta />
    </>
  );
}
